// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","contentBox":"Modal_contentBox__2oCfy"};